import { ErrorStateComposableCard } from 'components/masonry-custom/error-state-composable-card/error-state-composable-card.component';
import { VirtualComposableCard } from 'components/masonry-custom/virtual-composable-card/virtual-composable-card.component';
import { SidebarImageBanner } from 'components/masonry-custom/sidebar-image-banner/sidebar-image-banner.component';
import { driver } from '@leagueplatform/masonry';
import { ResponsiveHiddenContainerRenderer } from 'components/masonry-custom/responsive-hidden-container/responsive-hidden-container.component';
import { CollapsibleVerticalLayoutRenderer } from 'components/masonry-custom/collapsible-vertical-layout/collapsible-vertical-layout.component';
import { RichTextContentBlockRenderer } from 'components/masonry-custom/rich-text-content-block/rich-text-content-block.component';
import { RichTextSectionHeaderRenderer } from 'components/masonry-custom/rich-text-section-header/rich-text-section-header.component';
import { ConsultationCtaCard } from 'components/masonry-custom/consultation-cta-card/consultation-cta-card.component';
import { LinkClinicResultModal } from 'components/masonry-custom/link-clinic-result-modal/link-clinic-result-modal.component';
import { BookAppointmentDataProcessorActionHandler } from 'actions/book-appointment/book-appointment.action';
import { LinkClinicDataProcessorActionHandler } from 'actions/link-clinic/link-clinic.action';

const CUSTOM_MASONRY_NAMESPACES = {
  ERROR: 'medibank-pp-error',
  SIDEBAR_IMAGE_BANNER: 'medibank-pp-sidebar-image-banner',
  SIDEBAR_CONTENT: 'medibank-pp-sidebar',
  RICH_TEXT_SECTION_HEADER: 'medibank-pp-rich-text-section-header',
  RICH_TEXT_CONTENT_BLOCK: 'medibank-pp-rich-text-content-block',
  CONSULTATION_CTA_CARD: 'medibank-pp-consultation-cta-card',
  VIRTUAL_APPOINTMENT_CARD: 'medibank-pp-virtual-appointment-card',
  DEFAULT: 'medibank-pp',
  BOOK_APPOINTMENT_DATA_PROCESSOR: 'medibank-pp-book-appointment',
  LINK_CLINIC: 'medibank-pp-link-clinic',
  LINK_CLINIC_RESULT_MODAL: 'medibank-pp-link-clinic-result-modal',
} as const;

export const initMasonryRegistry = () => {
  driver.nodeRendererRegistry.registerRenderer(
    'composableCard',
    CUSTOM_MASONRY_NAMESPACES.ERROR,
    ErrorStateComposableCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'composableCard',
    CUSTOM_MASONRY_NAMESPACES.VIRTUAL_APPOINTMENT_CARD,
    VirtualComposableCard,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'composableCard',
    CUSTOM_MASONRY_NAMESPACES.LINK_CLINIC_RESULT_MODAL,
    LinkClinicResultModal,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'imageBanner',
    CUSTOM_MASONRY_NAMESPACES.SIDEBAR_IMAGE_BANNER,
    SidebarImageBanner,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'responsiveHiddenContainer',
    CUSTOM_MASONRY_NAMESPACES.DEFAULT,
    ResponsiveHiddenContainerRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'verticalLayout',
    CUSTOM_MASONRY_NAMESPACES.SIDEBAR_CONTENT,
    CollapsibleVerticalLayoutRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'sectionHeader',
    CUSTOM_MASONRY_NAMESPACES.RICH_TEXT_SECTION_HEADER,
    RichTextSectionHeaderRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'contentBlock',
    CUSTOM_MASONRY_NAMESPACES.RICH_TEXT_CONTENT_BLOCK,
    RichTextContentBlockRenderer,
  );

  driver.nodeRendererRegistry.registerRenderer(
    'ctaCard',
    CUSTOM_MASONRY_NAMESPACES.CONSULTATION_CTA_CARD,
    ConsultationCtaCard,
  );

  // Action handlers
  driver.actionController.registerHandler(
    'invokeDataProcessor',
    CUSTOM_MASONRY_NAMESPACES.BOOK_APPOINTMENT_DATA_PROCESSOR,
    BookAppointmentDataProcessorActionHandler,
  );

  driver.actionController.registerHandler(
    'invokeDataProcessor',
    CUSTOM_MASONRY_NAMESPACES.LINK_CLINIC,
    LinkClinicDataProcessorActionHandler,
  );
};
